export enum ReleaseNoteDisplayKind {
  BANNER = 'BANNER',
  POPUP = 'POPUP'
}
